import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "linear-background card",
  style: {"min-height":"100%"}
}
const _hoisted_2 = { class: "card-body p-0" }
const _hoisted_3 = { class: "d-flex flex-stack" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "m-0 text-white fw-bolder fs-3" }, "Ads Summary", -1)
const _hoisted_5 = { class: "ms-1" }
const _hoisted_6 = { class: "svg-icon svg-icon-2" }
const _hoisted_7 = { class: "d-flex text-center flex-column text-white pt-8" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold fs-7" }, "total number of Ads", -1)
const _hoisted_9 = { class: "fw-bolder fs-2x pt-1" }
const _hoisted_10 = { class: "d-flex text-center flex-column text-white pt-8" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "fw-bold fs-7" }, "Unique Ads", -1)
const _hoisted_12 = { class: "fw-bolder fs-2x pt-1" }
const _hoisted_13 = {
  class: "shadow-xs card-rounded mx-9 mb-9 px-6 py-9 position-relative z-index-1 bg-white",
  style: {"margin-top":"-50px"}
}
const _hoisted_14 = { class: "symbol symbol-45px w-40px me-5" }
const _hoisted_15 = { class: "symbol-label bg-lighten" }
const _hoisted_16 = { class: "svg-icon svg-icon-1" }
const _hoisted_17 = { class: "d-flex align-items-center flex-wrap w-100" }
const _hoisted_18 = { class: "mb-1 pe-3 flex-grow-1" }
const _hoisted_19 = {
  href: "#",
  class: "fs-5 text-gray-800 text-hover-primary fw-bolder"
}
const _hoisted_20 = { class: "text-gray-400 fw-bold fs-7" }
const _hoisted_21 = { class: "d-flex align-items-center" }
const _hoisted_22 = { class: "fw-bolder fs-5 text-gray-800 pe-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_AdsFilterWidgets = _resolveComponent("AdsFilterWidgets")!
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1))
      : _createCommentVNode("", true),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass([_ctx.widgetClasses, "card"])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: _normalizeClass([`bg-${_ctx.widgetColor}`, "px-9 pt-7 card-rounded h-275px w-100"])
            }, [
              _createElementVNode("div", _hoisted_3, [
                _hoisted_4,
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("button", {
                    type: "button",
                    class: _normalizeClass([`btn-active-color-${_ctx.widgetColor}`, "btn btn-sm btn-icon btn-color-white btn-active-white border-0 me-n3"]),
                    "data-kt-menu-trigger": "click",
                    "data-kt-menu-placement": "bottom-end",
                    "data-kt-menu-flip": "top-end"
                  }, [
                    _createElementVNode("span", _hoisted_6, [
                      _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen024.svg" })
                    ])
                  ], 2),
                  _createVNode(_component_AdsFilterWidgets, {
                    onFilterSelected: _ctx.onTypeChange,
                    onReset: _ctx.onReset
                  }, null, 8, ["onFilterSelected", "onReset"])
                ])
              ]),
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.data.data.totalAds), 1)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _hoisted_11,
                _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.data.data.UtotalAds), 1)
              ])
            ], 2),
            _createElementVNode("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: _normalizeClass([[index !== _ctx.items.length && 'mb-7'], "d-flex align-items-center"])
                }, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("span", _hoisted_15, [
                      _createElementVNode("span", _hoisted_16, [
                        _createVNode(_component_inline_svg, {
                          src: item.icon
                        }, null, 8, ["src"])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_17, [
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("a", _hoisted_19, _toDisplayString(item.title), 1),
                      _createElementVNode("div", _hoisted_20, _toDisplayString(item.description), 1)
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, _toDisplayString(item.stats), 1)
                    ])
                  ])
                ], 2))
              }), 128))
            ])
          ]),
          _createVNode(_component_apexchart, {
            class: "mixed-widget-6-chart card-rounded-bottom",
            options: _ctx.chartOptions,
            series: _ctx.series,
            height: _ctx.chartHeight,
            type: "area"
          }, null, 8, ["options", "series", "height"])
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}